import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import { NipNavbar } from "./Navbar";
import NipSidebar from "./Sidebar";

const NipWrapper2 = ({ children, currentRoute }) => {
  return (
    <div className="container">
      <NipNavbar />
      <NipSidebar />

      <div className="container-body-staff">
        <div className="general-wrapper2">
          <div className="top">
            <div className="general-wrapper2-left">
              <div className="nip-trail-header">
                <h1>NIP Integration</h1>
                <p>
                  Welcome to the NIBSS NIP Integration where you’ll learn how to
                  build amazing payment experiences with the NIBSS NIP API.
                </p>
              </div>
            </div>
            <div className="general-wrapper2-right">
              {
                <div className="general-wrapper2-right-links">
                  <NavLink to="/nip/home" activeClassName="nip-bar">
                    <div className="link-1">Test Environment</div>
                  </NavLink>
                  <NavLink to="/nip/integration" activeClassName="nip-bar">
                    <div className="link-2">
                      {window.location.pathname === currentRoute
                        ? "Back"
                        : "Integration"}
                    </div>
                  </NavLink>
                </div>
              }
            </div>
          </div>

          <div className="bottom">{children}</div>
        </div>
      </div>
    </div>
  );
};

NipWrapper2.propTypes = {
  children: PropTypes.any,
  currentRoute: PropTypes.any,
};

export default NipWrapper2;
